module.exports = __webpack_public_path__ + "assets/img/teacher (42).b2538cf0.png";